
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/identity/identity-document-upload",
      function () {
        return require("private-next-pages/docs/identity/identity-document-upload.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/identity/identity-document-upload"])
      });
    }
  